import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { CreateBrandPage } from "@/features/brands/create";
import { usePageTitle } from "@/hooks/usePageTitle";

export const Route = createFileRoute("/_auth/_app-shell/brands/create")({
  component: RouteComponent,
  validateSearch: z.object({
    "project-id": z.coerce.number().positive().optional(),
  }),
});

function RouteComponent() {
  usePageTitle("Create Brand");

  return (
    <main className="flex items-center content-center bg-bg-tertiary sm:py-4xl sm:px-4xl">
      <CreateBrandPage />
    </main>
  );
}
